/**
 * @copyright (C) Microsoft Corporation.
 * All Rights Reserved.
 */

export const specialties: string[] = [
    "Acupuncturist",
    "Addiction Medicine",
    "Addiction Psychiatry",
    "Adolescent Medicine",
    "Adult Reconstructive Orthopaedic Surgery",
    "Advanced Heart Failure and Transplant",
    "Aerospace Medicine",
    "Allergy & Immunology",
    "Anesthesiology",
    "Audiologist",
    "Bariatric Surgery",
    "Behavior Medicine",
    "Cardiac Surgery",
    "Cardiology",
    "Cardiovascular Disease/Cardiology",
    "Case Manager/Care Coordinator",
    "Child & Adolescent Psychiatry",
    "Child Abuse Pediatrics",
    "Chiropractor",
    "Clinical Cardiac Electrophysiology",
    "Colorectal Surgery",
    "Colorectal Surgery (Proctology)",
    "Counselor",
    "Critical Care Medicine",
    "Dental Hygienist",
    "Dentist",
    "Dermatology",
    "Developmental - Behavioral Pediatrics",
    "Diagnostic Radiology",
    "Dietitian, Registered",
    "Emergency Care Clinic/Center",
    "Emergency Medical Technician, Paramedic",
    "Emergency Medicine",
    "Endocrinology",
    "Family Medicine",
    "Family Practice",
    "Gastroenterology",
    "General Practice",
    "General Surgery",
    "Genetics Medicine",
    "Geriatric Medicine",
    "Geriatric Psychiatry",
    "Gynecological Oncology",
    "Gynecology",
    "Hand Surgery",
    "Hematology",
    "Hematology & Oncology",
    "Hepatology",
    "Home Health",
    "Home Health Aide",
    "Homeopath",
    "Hospice and Palliative Care",
    "Hospital setting",
    "Hospitalist",
    "Infectious Disease",
    "Integrative Medicine",
    "Internal Medicine",
    "Interventional Cardiology",
    "Interventional Pain Management",
    "Interventional Radiology",
    "Licensed Practical Nurse",
    "Licensed Psychiatric Technician",
    "Marriage & Family Therapist",
    "Maternal Fetal Health",
    "Maxillofacial Surgery",
    "Medical Oncology",
    "Medical Toxicology",
    "Midwife",
    "Military Health Care Provider",
    "Nephrology",
    "Neurological Surgery/Neurosurgery",
    "Neurology",
    "Neuro-ophthalmology",
    "Neuropsychiatry",
    "Neuropsychology",
    "Neurosurgery",
    "Nuclear Medicine",
    "Nurse Practitioner",
    "Nurse Practitioner - Acute Care",
    "Nurse Practitioner - Adult Health",
    "Nurse Practitioner - Community Health",
    "Nurse Practitioner - Critical Care Medicine",
    "Nurse Practitioner - Family",
    "Nurse Practitioner - Gerontology",
    "Nurse Practitioner - Neonatal",
    "Nurse Practitioner - Neonatal, Critical Care",
    "Nurse Practitioner - Obstetrics & Gynecology",
    "Nurse Practitioner - Occupational Health",
    "Nurse Practitioner - Pediatrics",
    "Nurse Practitioner - Perinatal",
    "Nurse Practitioner - Primary Care",
    "Nurse Practitioner - Psychiatric/Mental Health",
    "Nurse Practitioner - School",
    "Nurse Practitioner - Women's Health",
    "Nursing Facility/Intermediate Care Facility",
    "Obstetrics",
    "Obstetrics & Gynecology",
    "Occupational Medicine",
    "Occupational Therapist",
    "Ophthalmic Plastic and Reconstructive Surgery",
    "Ophthalmic Technician/Technologist",
    "Ophthalmology",
    "Ophthalmology - Cornea and External Diseases Specialist",
    "Ophthalmology - Glaucoma Specialist",
    "Ophthalmology - Retina Specialist",
    "Ophthalmology - Uveitis and Ocular Inflammatory Disease",
    "Optometrist",
    "Optometry - Low Vision Rehabilitation",
    "Optometry - Pediatrics",
    "Orthopaedic Surgery of the Spine",
    "Orthopaedic Trauma",
    "Orthopedic Surgery",
    "Orthopedic Surgery - Foot and Ankle Surgery",
    "Orthoptist",
    "Orthotist",
    "Osteopathic Manipulative Medicine",
    "Other",
    "Otolaryngology",
    "Otolaryngology - Facial Plastic Surgery",
    "Otolaryngology - Otolaryngic Allergy",
    "Otolaryngology - Otolaryngology/Facial Plastic Surgery",
    "Otolaryngology - Otology & Neurotology",
    "Otolaryngology - Plastic Surgery within the Head & Neck",
    "Otolaryngology - Sleep Medicine",
    "Pain Management",
    "Pain Medicine & Pain Management",
    "Pathology",
    "Pediatric Allergy/Immunology",
    "Pediatric Cardiology",
    "Pediatric Critical Care Medicine",
    "Pediatric Dermatology",
    "Pediatric Emergency Medicine",
    "Pediatric Endocrinology",
    "Pediatric Gastroenterology",
    "Pediatric Hematology-Oncology",
    "Pediatric Infectious Diseases",
    "Pediatric Medicine",
    "Pediatric Nephrology",
    "Pediatric Neurology",
    "Pediatric Ophthalmology and Strabismus Specialist",
    "Pediatric Orthopaedic Surgery",
    "Pediatric Otolaryngology",
    "Pediatric Pulmonology",
    "Pediatric Rehabilitation Medicine",
    "Pediatric Rheumatology",
    "Pediatric Urology",
    "Pediatrics Adolescent Medicine",
    "Pediatrics Neonatal-Perinatal Medicine",
    "Pediatrics Neurodevelopmental Disabilities",
    "Peripheral Vascular Disease",
    "Pharmacist",
    "Physical Medicine & Rehabilitation",
    "Physical Therapist",
    "Physician Assistant",
    "Plastic and Reconstructive Surgery",
    "Plastic Surgery",
    "Podiatrist",
    "Preventative Medicine",
    "Preventive Medicine",
    "Procedural Dermatology",
    "Psychiatry",
    "Psychoanalysis",
    "Psychologist",
    "Psychologist - Addiction (Substance Use Disorder)",
    "Psychologist - Clinical Child & Adolescent",
    "Psychologist - School",
    "Psychosomatic Medicine",
    "Pulmonary Disease/Pulmonology",
    "Radiation Oncology",
    "Radiology & Diagnostic Radiology",
    "Registered Nurse",
    "Registered Nurse - Case Management",
    "Registered Nurse - Critical Care Medicine",
    "Registered Nurse - Diabetes Educator",
    "Registered Nurse - Dialysis, Peritoneal",
    "Registered Nurse - Home Health",
    "Registered Nurse - Obstetric, Inpatient",
    "Registered Nurse - Occupational Health",
    "Registered Nurse - Oncology",
    "Registered Nurse - Ophthalmic",
    "Registered Nurse - Orthopedic",
    "Registered Nurse - Ostomy Care",
    "Registered Nurse - Otorhinolaryngology & Head-Neck",
    "Registered Nurse - Pain Management",
    "Registered Nurse - Pediatric Oncology",
    "Registered Nurse - Pediatrics",
    "Registered Nurse - Perinatal",
    "Registered Nurse - Plastic Surgery",
    "Registered Nurse - Psychiatric/Mental Health",
    "Registered Nurse - Rehabilitation",
    "Registered Nurse - School",
    "Registered Nurse - Urology",
    "Registered Nurse - Wound Care",
    "Reproductive Endocrinology",
    "Respiratory Therapist, Registered",
    "Rheumatology",
    "Sleep Medicine",
    "Social Worker",
    "Social Worker - School",
    "Speech-Language Pathologist",
    "Sports Medicine",
    "Surgery - Pediatrics",
    "Surgical Oncology",
    "Thoracic Surgery",
    "Triage",
    "Triage - Emergency Medicine",
    "Urgent Care Clinic / Center",
    "Urology",
    "Vascular Surgery",
    "Wound Care"
];
